import {Injectable} from '@angular/core';
import {FascicoloFull} from "../../../common/models/fascicolo/fascicolo-full";
import {RowSezione} from "../../../common/models/fascicolo/row-sezione";
import {VoceSezione} from "../../../common/models/fascicolo/voce-sezione";
import {FormAccessoagliattiComponent} from "../form-accessoagliatti/form-accessoagliatti.component";
import {FormAccessoagliattiViewComponent} from "../form-accessoagliatti/view/form-accessoagliatti-view.component";
import {
  FormAltrerisoluzionilavoroComponent
} from "../form-altrerisoluzionilavoro/form-altrerisoluzionilavoro.component";
import {
  FormAltrerisoluzionilavoroViewComponent
} from "../form-altrerisoluzionilavoro/view/form-altrerisoluzionilavoro-view.component";
import {FormDisciplinaComponent} from "../form-disciplina/form-disciplina.component";
import {FormDisciplinaViewComponent} from "../form-disciplina/view/form-disciplina-view.component";
import {
  FormOpposaiserviziispettiviComponent
} from "../form-opposaiserviziispettivi/form-opposaiserviziispettivi.component";
import {
  FormOpposaiserviziispettiviViewComponent
} from "../form-opposaiserviziispettivi/view/form-opposaiserviziispettivi-view.component";
import {FormParereComponent} from "../form-parere/form-parere.component";
import {FormParereViewComponent} from "../form-parere/view/form-parere-view.component";
import {FascicoloAccessoagliatti} from "../models/accessoagliatti/fascicolo-accessoagliatti";
import {FascicoloAltrerisoluzionilavoro} from "../models/altrerisoluzionilavoro/fascicolo-altrerisoluzionilavoro";
import {FascicoloDisciplina} from "../models/disciplina/fascicolo-disciplina";
import {FascicoloOpposaiserviziispettivi} from "../models/opposaiserviziispettivi/fascicolo-opposaiserviziispettivi";
import {FascicoloParere} from "../models/parere/fascicolo-parere";
import {FascicoloConsulenza} from '../models/consulenza/fascicolo-consulenza';
import {FormConsulenzaComponent} from '../form-consulenza/form-consulenza.component';
import {FormConsulenzaViewComponent} from '../form-consulenza/view/form-consulenza-view.component';
import {FascicoloGestioneAmministrativa} from '../models/gestioneamministrativa/fascicolo-gestione-amministrativa';
import {
  FormGestioneAmministrativaComponent
} from '../form-gestione-amministrativa/form-gestione-amministrativa.component';
import {
  FormGestioneAmministrativaViewComponent
} from '../form-gestione-amministrativa/view/form-gestione-amministrativa-view.component';
import {FascicoloGenerico} from '../models/generico/fascicolo-generico';
import {FormGenericoViewComponent} from '../form-generico/view/form-generico-view.component';
import {FormGenericoComponent} from '../form-generico/form-generico.component';


@Injectable({
  providedIn: 'root'
})

export class FascicoloService {

  constructor() {
  }

  getFascicolo(genericFascicolo): any {
    let fascicolo;
    switch (genericFascicolo) {
      case 'parere': {
        fascicolo = new FascicoloParere();
        break;
      }
      case 'consulenza': {
        fascicolo = new FascicoloConsulenza();
        break;
      }
      case 'gestioneamministrativa': {
        fascicolo = new FascicoloGestioneAmministrativa();
        break;
      }
      case 'genericoconsulenza': {
        fascicolo = new FascicoloGenerico();
        break;
      }
      case 'disciplina': {
        fascicolo = new FascicoloDisciplina();
        break;
      }
      case 'altrerisoluzionilavoro': {
        fascicolo = new FascicoloAltrerisoluzionilavoro();
        break;
      }
      case 'accessoagliatti': {
        fascicolo = new FascicoloAccessoagliatti();
        break;
      }
      case 'opposaiserviziispettivi': {
        fascicolo = new FascicoloOpposaiserviziispettivi();
        break;
      }
    }
    return fascicolo;
  }

  getComponentFromFormTenant(idFormTenant, view = false) {
    let component;

    switch (idFormTenant) {
      case 'ParPar_PRD': {
        component = view ? FormParereViewComponent : FormParereComponent;
        break;
      }
      case 'ParCons_PRD': {
        component = view ? FormConsulenzaViewComponent : FormConsulenzaComponent;
        break;
      }
      case 'ParGes_PRD': {
        component = view ? FormGestioneAmministrativaViewComponent : FormGestioneAmministrativaComponent;
        break;
      }
      case 'ParGen_PRD': {
        component = view ? FormGenericoViewComponent : FormGenericoComponent;
        break;
      }

      case 'ParDis_PRD': {
        component = view ? FormDisciplinaViewComponent : FormDisciplinaComponent;
        break;
      }
      case 'ParAlt_PRD': {
        component = view ? FormAltrerisoluzionilavoroViewComponent : FormAltrerisoluzionilavoroComponent;
        break;
      }
      case 'ParAcc_PRD': {
        component = view ? FormAccessoagliattiViewComponent : FormAccessoagliattiComponent;
        break;
      }
      case 'ParOsi_PRD': {
        component = view ? FormOpposaiserviziispettiviViewComponent : FormOpposaiserviziispettiviComponent;
        break;
      }
    }
    return component;
  }

  getMappaCopertinaFascicolo(genericFascicolo: string, fascicolo: FascicoloFull, viewComponentDynamic: string, assegnatario?: string): RowSezione[] {
    // todo: ottimizzare funzione + gestire viewComponentDynamic;
    let udienzeEsiti = this.getUdienzeEsitiFromCopertina(fascicolo);
    switch (genericFascicolo) {
      case 'consulenza':
      case 'gestioneamministrativa':
      case 'genericoconsulenza':
      case 'disciplina':
      case 'altrerisoluzionilavoro':
      case 'accessoagliatti':
      case 'opposaiserviziispettivi': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
          // new VoceSezione(4, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(3, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(3, 'date', 'Data apertura', fascicolo.dataInizioFascicolo),
            new VoceSezione(3, 'date', 'Data Notifica', fascicolo.dataNotifica),
            new VoceSezione(3, 'text', 'Parti', fascicolo.copertina.campi.parti)
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'text', 'Tipologia', null != fascicolo.tipologiaGenericoConsulenza ? fascicolo.tipologiaGenericoConsulenza.label : '')
          ]),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]), 
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
      case 'parere': {
        return [new RowSezione(null, [
          new VoceSezione(3, 'text', 'Posizione', fascicolo.copertina.campi.identificativoFascicolo),
          new VoceSezione(3, 'text', 'Vecchia posizione', fascicolo.vecchiaPosizione),
          new VoceSezione(3, 'text', 'Tipo Fascicolo', fascicolo.copertina.campi.tipo),
          new VoceSezione(3, 'text', 'Stato', fascicolo.copertina.campi.stato)
          // new VoceSezione(4, 'text', 'Natura', fascicolo.copertina.campi.natura)
        ]),
          new RowSezione(null, [
            new VoceSezione(4, 'text', 'Assegnatario', assegnatario),
            new VoceSezione(4, 'date', 'Data apertura', fascicolo.dataInizioFascicolo),
            new VoceSezione(4, 'date', 'Data Notifica', fascicolo.dataNotifica),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Soggetti richiedenti', fascicolo.copertina.campi.parti),
          ]),
          new RowSezione(null, [
            new VoceSezione(12, 'textarea', 'Descrizione oggetto', fascicolo.descrizioneOggetto),
          ]),
          new RowSezione('Richiesta parere', [
            new VoceSezione(6, 'text', 'Tipo richiedente', fascicolo.copertina.campi.tipoRichiedente),
            new VoceSezione(6, 'text', 'Quesito', fascicolo.copertina.campi.richiesta)
          ]),
          new RowSezione('Parere', [
            new VoceSezione(12, 'text', 'Sintesi parere', fascicolo.copertina.campi.sintesiParere)
          ]),
          udienzeEsiti.length > 0 ? new RowSezione("Udienze",udienzeEsiti) : new RowSezione(null,null),
          new RowSezione('Prossima udienza', [
            //new VoceSezione(4, 'date', 'Ultima udienza', fascicolo.copertina.campi.ultimaUdienza),
            new VoceSezione(6, 'text', 'Adempimento', fascicolo.copertina.campi.prossimaUdienzaTipoAdempimento),
            new VoceSezione(6, 'date', 'Prossima udienza', fascicolo.copertina.campi.prossimaUdienza),
            //new VoceSezione(4, 'date', 'Prossima scadenza', fascicolo.copertina.campi.prossimaScadenza)
          ]), 
          new RowSezione('Competenze ', [
            new VoceSezione(12, 'text', 'Gruppi competenti', fascicolo.copertina.campi.competenza)
          ]),
        ];
        break;
      }
    }
  }
  getUdienzeEsitiFromCopertina(fascicolo: FascicoloFull): any[] {
    let listaVoci = [];
    if (fascicolo.copertina.campi.scadenze) {
      for (let i = 0; i < fascicolo.copertina.campi.scadenze.length; i++) {
        let esitoUdienza = fascicolo.copertina.campi.scadenze[i];
    
        listaVoci.push(new VoceSezione(4, "text", "Adempimento", esitoUdienza.tipoAdempimento ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data udienza", esitoUdienza.dataUdienza ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Tipo provvedimento", esitoUdienza.tipoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Numero/Anno esito", esitoUdienza.numeroAnnoEsito ?? ""));
        listaVoci.push(new VoceSezione(4, "date", "Data pubblicazione", esitoUdienza.dataPubblicazione ?? ""));
        listaVoci.push(new VoceSezione(4, "text", "Esito", esitoUdienza.esito ?? ""));
        listaVoci.push(new VoceSezione(12, "text", "Note udienza", esitoUdienza.noteUdienza ?? ""));    
        // Aggiungi il divider solo se ci sono almeno due elementi e NON per l'ultima iterazione
        if (fascicolo.copertina.campi.scadenze.length > 1 && i < fascicolo.copertina.campi.scadenze.length - 1) {
          listaVoci.push(new VoceSezione(12, "divider", "", ""));
        }
      }
    }
     
    return listaVoci;
  }
}
